var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3459 5V12.3125C14.3459 12.5363 14.257 12.7509 14.0988 12.9091C13.9406 13.0674 13.7259 13.1562 13.5022 13.1562C13.2784 13.1562 13.0638 13.0674 12.9055 12.9091C12.7473 12.7509 12.6584 12.5363 12.6584 12.3125V7.03906L5.09912 14.597C4.94061 14.7555 4.72563 14.8445 4.50146 14.8445C4.2773 14.8445 4.06232 14.7555 3.90381 14.597C3.7453 14.4384 3.65625 14.2235 3.65625 13.9993C3.65625 13.7751 3.7453 13.5601 3.90381 13.4016L11.4631 5.84375H6.18967C5.96589 5.84375 5.75128 5.75486 5.59305 5.59662C5.43481 5.43839 5.34592 5.22378 5.34592 5C5.34592 4.77622 5.43481 4.56161 5.59305 4.40338C5.75128 4.24514 5.96589 4.15625 6.18967 4.15625H13.5022C13.7259 4.15625 13.9406 4.24514 14.0988 4.40338C14.257 4.56161 14.3459 4.77622 14.3459 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.86a385cda03c7b05e39bd5fdd5dabb59.svg";
export { ForwardRef as ReactComponent };